import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import DoneBanner from '../done_banner';
import AutocompleteBootstrap5 from '../../../../autocompletes/autocomplete_bootstrap_5';
import { autocompletePlacesPath } from '../../../../../../utilities/api_relative_paths';
import { updateField } from '../../../services';

const CountryBanner = ({ userID, value, removeBanner }) => {
  const [step, setStep] = useState('edit');
  const [country, setCountry] = useState(value);

  useEffect(() => {
    if (step === 'done') {
      setTimeout(removeBanner, 7000);
    }
  }, [step]);

  /**
   * Formats the selected country to be saved as is expected to be received in the BE.
   *
   * @param {object} selected country selected with autocomplete
   * @returns {undefined}
   */
  const onSelect = (selected) => {
    if (selected) {
      const element = {
        id: selected.id.substr(8),
        placeKey: selected.id,
        name: selected.text,
        text: selected.text,
      };

      setCountry(element);
    }
  };

  const displayCountry = () => {
    if (!country) return '';
    return (
      <span className='filter-buttons'>
        <span>
          <button
            aria-label='country'
            className='btn btn-removable'
            type='button'
            onClick={() => setCountry(null)}
          >
            {country.name || country.text}
          </button>
        </span>
      </span>
    );
  };

  const handleUpdate = () => {
    const data = {
      consultant: {
        country,
        country_id: country.id,
      },
    };
    updateField('country', data, userID);
    setStep('done');
  };

  if (step === 'done') return <DoneBanner action='updating' />;
  return (
    <div className='data-input' data-testid='edit-country'>
      <div className='form-group mb-3'>
        <label className='mb-35 text-center'>
          {`
            Profiles with location information appear higher in candidate search\
            results and are seen by more recruiters.
            Add yours below to give your profile a boost.
          `}
        </label>
        {displayCountry()}
        <AutocompleteBootstrap5
          inputProps={{ className: 'form-control' }}
          placeholder='Select location'
          id='placesAutocomplete'
          apiPath={autocompletePlacesPath}
          onSelect={onSelect}
          selected={[]}
          filter={{ types: ['Country'] }}
          disabled={!!country}
        />
      </div>
      <div className='text-center'>
        <button className='btn btn-outline-primary' type='button' onClick={handleUpdate}>
          Update
        </button>
      </div>
    </div>
  );
};

CountryBanner.propTypes = {
  userID: PropTypes.number.isRequired,
  value: PropTypes.object,
  removeBanner: PropTypes.func.isRequired,
};

export default CountryBanner;
